import { VIRTUAL_USER_GAP_SEVERITY } from '@demandproai/shared';

// A draft row on its own never says why the agent stopped. The persisted gap report is the whole
// account of the run, so the top blocking reason is named here and the count points at the rest.
export const buildCaseReviewMessage = ({ gapReport = [] }) => {
  const blockingGaps = (gapReport ?? []).filter(({ severity }) => severity === VIRTUAL_USER_GAP_SEVERITY.BLOCKING);

  if (!blockingGaps.length) return '';

  const [{ title }] = blockingGaps;
  const remaining = blockingGaps.length - 1;

  return remaining ? `${title} (+${remaining} more to review)` : title;
};
